import tagTester from './_tagTester.js';
import { root } from './_setup.js';

var isFunction = tagTester('Function');

// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var nodelist = root.document && root.document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
  isFunction = function(obj) {
    return typeof obj == 'function' || false;
  };
}

export default isFunction;



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isFunction.js
// module id = 44
// module chunks = 0